import type { BulkAction, BulkActionRequest } from '../../../types/bookmark'

/**
 * 일괄 작업 되돌리기.
 *
 * 작업 직전의 값을 알면 반대 작업으로 되돌릴 수 있다. 삭제만은
 * 복구 수단이 없으므로 되돌리기를 만들지 않는다 — 없는 기능을
 * 있는 것처럼 보여 주지 않기 위해서다.
 */

export interface BulkSnapshotItem {
  _id: string
  folderId: string | null
  isFavorite: boolean
}

/** key 가 같은 항목끼리 묶어 순서를 지킨 채 돌려준다 */
function groupBy<K>(
  items: BulkSnapshotItem[],
  key: (item: BulkSnapshotItem) => K
): Array<[K, string[]]> {
  const groups = new Map<K, string[]>()
  items.forEach(item => {
    const group = groups.get(key(item))
    if (group) {
      group.push(item._id)
    } else {
      groups.set(key(item), [item._id])
    }
  })
  return Array.from(groups.entries())
}

export function buildUndoRequests(
  action: BulkAction,
  items: BulkSnapshotItem[]
): BulkActionRequest[] {
  if (items.length === 0) {
    return []
  }

  if (action === 'move') {
    return groupBy(items, item => item.folderId).map(([folderId, urlIds]) => ({
      action: 'move' as const,
      urlIds,
      folderId,
    }))
  }

  if (action === 'favorite') {
    return groupBy(items, item => item.isFavorite).map(
      ([isFavorite, urlIds]) => ({
        action: 'favorite' as const,
        urlIds,
        isFavorite,
      })
    )
  }

  return []
}
